"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisLayoutContext = void 0;
exports.useLayout = useLayout;
var react_1 = require("react");
exports.IpisLayoutContext = (0, react_1.createContext)({});
function useLayout() {
    return (0, react_1.useContext)(exports.IpisLayoutContext);
}
